module.exports = __webpack_public_path__ + "img/Follow.1e074c0b.png";